//get my content
export const GET_USER_LIST_REQUEST = "GET_USER_LIST_REQUEST";
export const GET_USER_LIST_RECEIVE = "GET_USER_LIST_RECEIVE";
export const GET_USER_LIST_FAILURE = "GET_USER_LIST_FAILURE";
export const RESET_GET_USER_LIST = "RESET_GET_USER_LIST";

export const POST_CONTENT_IN_CHAT_REQUEST = "POST_CONTENT_IN_CHAT_REQUEST";
export const POST_CONTENT_IN_CHAT_RECEIVE = "POST_CONTENT_IN_CHAT_RECEIVE";
export const POST_CONTENT_IN_CHAT_FAILURE = "POST_CONTENT_IN_CHAT_FAILURE";
export const RESET_POST_CONTENT_IN_CHAT = "RESET_POST_CONTENT_IN_CHAT";

export const GET_CHAT_POST_REQUEST = "GET_CHAT_POST_REQUEST";
export const GET_CHAT_POST_RECEIVE = "GET_CHAT_POST_RECEIVE";
export const GET_CHAT_POST_FAILURE = "GET_CHAT_POST_FAILURE";
export const RESET_GET_CHAT_POST = "RESET_POST_CONTENT_IN_CHAT";